import React from 'react'
import PropTypes from 'prop-types'

const SignUpButton = (props) => (
	<button className="SignUpButton" onClick={props.click}><span>{props.text}</span></button>
)

SignUpButton.propTypes = {
	click: PropTypes.func,
	text: PropTypes.string.isRequired
}

export default SignUpButton


// WEBPACK FOOTER //
// ./src/components/SignUpControl/SignUpButton.js